import React, { useState, useEffect } from 'react';
import { Modal, Text } from '@getpingback/realeza';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Button, TextField, Select, MenuItem } from '@material-ui/core';

const NewSaasPlanModal = ({ isOpen, onClose, onSubmit, isUpdating, dataForm }) => {
  const [formValues, setFormValues] = useState({
    id: dataForm ? dataForm.id : null,
    name: '',
    value: 0,
    periodOfMonths: 1,
    tier: '',
    type: '',
    emailSends: 0,
    contacts: 0,
    segmentation: 0,
    customTemplateEmail: 0,
    magIA: 0,
    workflow: 0,
    dailyEmailSends: 0,
    aiCredits: 0,
    publicApi: 0,
    workflowWebhook: 0,
    whatsAppNumbers: 0,
    channelMembers: 0,
    shortLinkDomains: 0,
    shortLinks: 0,
  });

  useEffect(() => {
    if (dataForm && isUpdating) {
      setFormValues({
        id: dataForm.id,
        name: dataForm.name,
        value: dataForm.value,
        periodOfMonths: dataForm.periodOfMonths,
        tier: dataForm.tier,
        type: dataForm.type,
        emailSends: dataForm.emailSends,
        contacts: dataForm.contacts,
        segmentation: dataForm.segmentation,
        customTemplateEmail: dataForm.customTemplateEmail,
        magIA: dataForm.magIA,
        workflow: dataForm.workflow,
        dailyEmailSends: dataForm.dailyEmailSends,
        aiCredits: dataForm.aiCredits,
        publicApi: dataForm.publicApi,
        workflowWebhook: dataForm.workflowWebhook,
        whatsAppNumbers: dataForm.whatsAppNumbers,
        channelMembers: dataForm.channelMembers,
        shortLinkDomains: dataForm.shortLinkDomains,
        shortLinks: dataForm.shortLinks,
      });
    }
  }, [dataForm]);

  const limits = {
    '-2': 'Unlimited',
    '-1': 'Has access',
    0: 'No access',
    greaterThan0: 'Limit restrictions',
  };

  const AccessTypesLegend = () => (
    <div className="saasPlans__modal__content__limits__top--legend">
      {Object.keys(limits).map((key, index) => (
        <span key={index}>
          <Text size={12} weight="bold" color="green" intensity={400}>
            {key === 'greaterThan0' ? 'Greater than 0' : key}
          </Text>
          : {limits[key]}
        </span>
      ))}
    </div>
  );

  return (
    <Modal onClose={onClose} isOpen={isOpen} className="saasPlans__modal">
      <div className="saasPlans__modal__top">
        <h2>New SaasPlan</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <div className="saasPlans__modal__content">
        <Text color="gray" intensity={200} size={18} weight="semibold" ml="24px" mt="24px">
          Saas Plan Infos
        </Text>
        <div>
          <TextField
            id="standard-basic"
            label="Plan Name"
            value={formValues.name}
            onChange={e => setFormValues({ ...formValues, name: e.target.value })}
            required
            variant="outlined"
            disabled={isUpdating}
          />

          <TextField
            id="standard-basic"
            label="Plan value"
            value={formValues.value}
            onChange={e => setFormValues({ ...formValues, value: e.target.value })}
            required
            variant="outlined"
            disabled={isUpdating}
            helperText="value with cents - Ex: 10000 (equal to R$ 100,00))"
          />

          <TextField
            id="standard-basic"
            label="Period Of Months"
            value={formValues.periodOfMonths}
            onChange={e => setFormValues({ ...formValues, periodOfMonths: e.target.value })}
            required
            variant="outlined"
            disabled={isUpdating}
          />
        </div>
        <div className="saasPlans__modal__content__selects">
          <div className="saasPlans__modal__content__selects--item">
            <Text color="gray" intensity={300} size={12}>
              Type
            </Text>
            <Select
              variant="outlined"
              value={formValues.type}
              defaultValue={formValues.type}
              onChange={e => setFormValues({ ...formValues, type: e.target.value })}
              required
              disabled={isUpdating}
            >
              <MenuItem value="single">Single</MenuItem>
              <MenuItem value="recurrent">Recurrent</MenuItem>
            </Select>
          </div>

          <div className="saasPlans__modal__content__selects--item">
            <Text color="gray" intensity={300} size={12}>
              Tier
            </Text>
            <Select
              variant="outlined"
              value={formValues.tier}
              defaultValue={formValues.tier}
              onChange={e => setFormValues({ ...formValues, tier: e.target.value })}
              required
              disabled={isUpdating}
            >
              <MenuItem value="tierFree">Free(tierFree)</MenuItem>
              <MenuItem value="tier0">Start(tier0)</MenuItem>
              <MenuItem value="tier1">Growth(tier1)</MenuItem>
              <MenuItem value="tier2">Scale(tier2)</MenuItem>
              <MenuItem value="null">Addon</MenuItem>
              <MenuItem value="tierCustom">Custom(tierCustom)</MenuItem>
            </Select>
          </div>
        </div>

        <div className="saasPlans__modal__content__limits">
          <div className="saasPlans__modal__content__limits__top">
            <Text color="gray" intensity={200} size={18} weight="semibold">
              Limits
            </Text>
            <AccessTypesLegend />
          </div>
          <div className="saasPlans__modal__content__limits__inputs">
            <div>
              <TextField
                id="standard-basic"
                type="number"
                label="Email Sends"
                value={formValues.emailSends}
                onChange={e => setFormValues({ ...formValues, emailSends: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="Contacts"
                value={formValues.contacts}
                onChange={e => setFormValues({ ...formValues, contacts: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="Segmentation"
                value={formValues.segmentation}
                onChange={e => setFormValues({ ...formValues, segmentation: e.target.value })}
                required
                variant="outlined"
              />
            </div>

            <div>
              <TextField
                id="standard-basic"
                type="number"
                label="Custom Template Email"
                value={formValues.customTemplateEmail}
                onChange={e => setFormValues({ ...formValues, customTemplateEmail: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="MagIA"
                value={formValues.magIA}
                onChange={e => setFormValues({ ...formValues, magIA: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="Workflow"
                value={formValues.workflow}
                onChange={e => setFormValues({ ...formValues, workflow: e.target.value })}
                required
                variant="outlined"
              />
            </div>

            <div>
              <TextField
                id="standard-basic"
                type="number"
                label="Daily Email Sends"
                value={formValues.dailyEmailSends}
                onChange={e => setFormValues({ ...formValues, dailyEmailSends: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="AI Credits"
                value={formValues.aiCredits}
                onChange={e => setFormValues({ ...formValues, aiCredits: e.target.value })}
                required
                variant="outlined"
              />
            </div>

            <div>
              <TextField
                id="standard-basic"
                type="number"
                label="Public API"
                value={formValues.publicApi}
                onChange={e => setFormValues({ ...formValues, publicApi: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="Workflow Webhook"
                value={formValues.workflowWebhook}
                onChange={e => setFormValues({ ...formValues, workflowWebhook: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="WhatsApp Numbers"
                value={formValues.whatsAppNumbers}
                onChange={e => setFormValues({ ...formValues, whatsAppNumbers: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="Channel Members"
                value={formValues.channelMembers}
                onChange={e => setFormValues({ ...formValues, channelMembers: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="Short Link Domains"
                value={formValues.shortLinkDomains}
                onChange={e => setFormValues({ ...formValues, shortLinkDomains: e.target.value })}
                required
                variant="outlined"
              />

              <TextField
                id="standard-basic"
                type="number"
                label="Short Links"
                value={formValues.shortLinks}
                onChange={e => setFormValues({ ...formValues, shortLinks: e.target.value })}
                required
                variant="outlined"
              />
            </div>
          </div>

          <Button variant="contained" onClick={() => onSubmit(formValues)}>
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NewSaasPlanModal;
